import React, { useReducer, Fragment, useEffect, useState } from "react";
import { CounterPartySimpleReducer, defaultState, initialize, validateForm } from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import style from "./CounterParty.module.scss";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import { Field, Combobox } from "../Order/Field/Field";
import CircularProgress from "../../CircularProgress/CircularProgress";
import CustodianEntity from "../CustodianEntity/CustodianEntity";
import { CounterPartyStatus } from "../../../utils/Helper";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";

const CounterParty = ({ open, toggle, fetchs, ...props }) => {
  const [state, dispatch] = useReducer(CounterPartySimpleReducer, defaultState(), initialize(props));
  const {
    counterparty,
    buttons,
    clearinghouse,
    clearingHouses,
    editClearingHouse,
    editClearingHouseId,
    conf,
    errors,
    sentAuthorization,
    message,
    custodianEntity,
    custodianEntityId,
    isEditCustodianEntity,
    openCustodianEntity,
  } = state;
  const [validCounterParty, setValidCounterParty] = useState({
    show: false,
    message: "",
  });

  useEffect(() => {
    props.callApiProxy("GetCounterParty", { counterPartyId: props.counterPartyId }).then((response) => {
      dispatch({ type: "SET_COUNTER_PARTY", response });
    });
    props.callApiProxy("GetCustodianEntity", {}).then((response) => {
      const custodianEntities = response.custodianEntity.filter((c) => c.id > 0);
      dispatch({ type: "GET_CUSTODIAN_ENTITY", response: { custodianEntity: custodianEntities } });
    });
  }, []);

  const RechargeCustodianEntity = (id) => {
    props.callApiProxy("GetCustodianEntity", {}).then((response) => {
      dispatch({ type: "RECHARGE_CUSTODIAN_ENTITY", response, id });
    });
  };

  const OpenCustodianEntity = () => {
    dispatch({ type: "OPEN_CUSTODIAN_ENTITY", ...props });
  };

  const EditCustodianEntity = () => {
    dispatch({ type: "EDIT_CUSTODIAN_ENTITY", ...props });
  };

  const CloseCustodianEntity = () => {
    dispatch({ type: "CLOSE_CUSTODIAN_ENTITY", ...props });
  };

  const update = () => {
    setValidCounterParty({
      ...validCounterParty,
      show: false,
      message: "",
    });
    props
      .callApiProxy("ValidCustodianEntity", {
        custodianEntityId: custodianEntityId,
      })
      .then((response) => {
        if (response.result.Code == 200) {
          dispatch({ type: "CONFIRM_COUNTER_PARTY" });
          if (counterparty.title !== "" && counterparty.limit !== 0) {
            dispatch({ type: "LOADING_COUNTER_PARTY" });
            var body = {
              counterPartyIn: {
                ...counterparty,
                CustodianEntityId: custodianEntityId,
              },
            };
            props.callApiProxy("UpdateCounterParty", body).then((response) => {
              dispatch({ type: "SENT_AUTHORIZATION_UPDATE", response });
            });
          }
        }
      });
  };

  const confirm = () => {
    setValidCounterParty({
      ...validCounterParty,
      show: false,
      message: "",
    });
    const errors = validateForm(state);
    console.log(errors);
    if (errors != false) {
      dispatch({ type: "SET_ERRORS_COUNTER_PARTY", errors: errors });
      return;
    }
    props
      .callApiProxy("ValidCustodianEntity", {
        custodianEntityId: custodianEntityId,
      })
      .then((response) => {
        if (response.result.Code == 200) {
          dispatch({ type: "CONFIRM_COUNTER_PARTY" });
          if (counterparty.title !== "" && counterparty.limit !== 0) {
            dispatch({ type: "LOADING_COUNTER_PARTY" });
            var body = {
              counterParty: {
                name: counterparty.CounterPartyName,
                email: counterparty.CounterPartyEmail,
                limit: counterparty.CounterPartyLimit,
                CustodianEntityId: custodianEntityId,
                clearingHouse: clearingHouses,
              },
            };
            props.callApiProxy("SetCounterParty", body).then((response) => {
              dispatch({ type: "SENT_AUTHORIZATION", response });
            });
          }
        } else {
          setValidCounterParty({
            ...validCounterParty,
            show: true,
            message: response.result.Description,
          });
        }
      });
  };

  const onChange = (fields) => dispatch({ type: "CHANGE_FIELDS", fields });

  const updateFields = (fields) => dispatch({ type: "UPDATE_FIELDS", fields });

  const ResetClose = () => {
    dispatch({ type: "RESET_CLOSE", ...props });
  };

  const onChangeCounterParty = (fields) => dispatch({ type: "UPDATE_COUNTERPARTY", fields });

  const globalReadOnly = buttons.confirm.loading;
  return (
    <div>
      <Modal isOpen={open} className={style.modal}>
        <ModalHeader toggle={toggle}>
          {props.editCounterParty ? "Edit Counter Party" : "New Counter Party"}
        </ModalHeader>
        {props.countriesloading || props.clearinghousesloading ? (
          <CircularProgress sm />
        ) : (
          <ModalBody className={style.body}>
            <Container>
              <Row>
                <Col lg={6} xs={12}>
                  <Field label={"Name"} error={errors.CounterPartyName}>
                    <Input
                      type={"text"}
                      placeholder={"Name"}
                      value={counterparty.CounterPartyName || ""}
                      invalid={errors.CounterPartyName}
                      onChange={(e) => onChange({ CounterPartyName: e.target.value })}
                    />
                  </Field>
                </Col>
                {props.editCounterParty == false && (
                  <Col lg={6} xs={12}>
                    <Field label={"Email"} error={errors.CounterPartyEmail}>
                      <Input
                        type={"text"}
                        placeholder={"Email"}
                        value={counterparty.CounterPartyEmail || ""}
                        invalid={errors.CounterPartyEmail}
                        onChange={(e) => onChange({ CounterPartyEmail: e.target.value })}
                      />
                    </Field>
                  </Col>
                )}
              </Row>
              {props.editCounterParty && (
                <Row>
                  <Col lg={6} xs={12}>
                    <Field label={"Email"} error={errors.CounterPartyEmail}>
                      <Input
                        type={"text"}
                        placeholder={"Email"}
                        value={counterparty.CounterPartyEmail || ""}
                        invalid={errors.CounterPartyEmail}
                        onChange={(e) => onChange({ CounterPartyEmail: e.target.value })}
                      />
                    </Field>
                  </Col>

                  <Col lg={6} xs={12}>
                    <Field label={"Clearing House Status"}>
                      <Combobox
                        style={{ background: "#edf9ff", fontWeight: 500 }}
                        value={counterparty.CounterPartyStatus}
                        onChange={(v) =>
                          onChange({
                            CounterPartyStatus: v,
                          })
                        }
                        items={Object.values(CounterPartyStatus).map((key, index) => ({
                          id: key.id,
                          description: key.name,
                        }))}
                      />
                    </Field>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg={5} xs={12} style={{ paddingRight: "0px" }}>
                  <Field label={"Custodian Entity"} error={errors.country}>
                    {custodianEntity && custodianEntity.length > 0 ? (
                      <Combobox
                        style={{ background: "#edf9ff", fontWeight: 500 }}
                        value={custodianEntityId}
                        onChange={(v) => updateFields({ custodianEntityId: v })}
                        items={Object.values(custodianEntity).map((key, index) => ({
                          id: key.id,
                          description: key.name,
                        }))}
                      />
                    ) : (
                      <p className="text-danger">There are not Custodian Entities.</p>
                    )}
                  </Field>
                </Col>
                <Col lg={1} xs={12} style={{ paddingLeft: "0px", display: "flex" }}>
                  <UncontrolledDropdown style={{ bottom: "0px", display: "contents" }}>
                    <DropdownToggle
                      style={{ top: "5px", position: "relative" }}
                      size="lg"
                      direction="down"
                      color="link"
                    >
                      <i class="fa fa-ellipsis-v fa-lg" aria-hidden="true"></i>
                    </DropdownToggle>

                    <DropdownMenu style={{ marginBottom: "5px" }}>
                      <DropdownItem onClick={() => OpenCustodianEntity()}>New</DropdownItem>
                      <DropdownItem onClick={() => EditCustodianEntity()}>Edit</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Col>
                <Col lg={6} xs={12}>
                  <Field label={"Limit"} error={errors.CounterPartyLimit}>
                    <NumberFormatInput
                      type="text"
                      customInput={Input}
                      placeholder={"Limit"}
                      value={counterparty.CounterPartyLimit || ""}
                      invalid={errors.CounterPartyLimit}
                      onValueChange={(e) => onChange({ CounterPartyLimit: e.value })}
                      dataTypeDecimalName="currency"
                    />
                  </Field>
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}
        {props.countriesloading || props.clearinghousesloading ? (
          <ModalFooter>
            <Button color="light" onClick={() => ResetClose()}>
              Close
            </Button>
          </ModalFooter>
        ) : (
          <ModalFooter>
            {sentAuthorization ? (
              <div>
                <div className={style.sentCounterParty}>{message}</div>
                <Button color="light" onClick={() => ResetClose()}>
                  Close
                </Button>
              </div>
            ) : (
              <div>
                {validCounterParty.show ? (
                  <div>
                    <div className={style.sentCounterParty}>{validCounterParty.message}</div>
                    <Button color="light" onClick={() => ResetClose()} style={{ marginRight: "5px" }}>
                      Close
                    </Button>
                    <LaddaButton
                      className={classnames("btn btn-ladda btn-primary")}
                      loading={buttons.confirm.loading}
                      onClick={() => confirm()}
                      data-style={EXPAND_RIGHT}
                    >
                      {props.editCounterParty ? "Update" : "Confirm"}
                    </LaddaButton>
                  </div>
                ) : (
                  <div>
                    <Button color="light" onClick={() => ResetClose()} style={{ marginRight: "5px" }}>
                      Close
                    </Button>
                    {props.editCounterParty ? (
                      <LaddaButton
                        className={classnames("btn btn-ladda btn-primary")}
                        loading={buttons.confirm.loading}
                        onClick={() => update()}
                        data-style={EXPAND_RIGHT}
                      >
                        {"Update"}
                      </LaddaButton>
                    ) : (
                      <LaddaButton
                        className={classnames("btn btn-ladda btn-primary")}
                        loading={buttons.confirm.loading}
                        onClick={() => confirm()}
                        data-style={EXPAND_RIGHT}
                      >
                        {"Confirm"}
                      </LaddaButton>
                    )}
                  </div>
                )}
              </div>
            )}
          </ModalFooter>
        )}
      </Modal>
      {openCustodianEntity ? (
        <CustodianEntity
          open={true}
          callApi={props.callApiProxy}
          CloseCustodianEntity={CloseCustodianEntity}
          isEditCustodianEntity={isEditCustodianEntity}
          entityId={custodianEntityId}
          RechargeCustodianEntity={RechargeCustodianEntity}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};

const EmptyClearingHouses = () => (
  <tr className={style.empty}>
    <td colSpan="3">
      <h5 style={{ textAlign: "center" }}>No Clearing Houses</h5>
    </td>
  </tr>
);

export function validations(alert) {
  return {
    CounterPartyName: { empty: true },
    CounterPartyEmail: { empty: true },
    CounterPartyLimit: { empty: true },
    CustodianEntityId: { empty: true, autosuggestId: "CustodianEntityId" },
  };
}

export default CounterParty;
